export const PUBLISH_COURSE_OPTION_SEMINAR = [
  { value: 'PUBLIC', label: 'company_seminar:common.public' },
  { value: 'PRIVATE', label: 'company_seminar:common.private' }
]

export const PUBLISH_COURSE_OPTION = [
  { value: 'PUBLIC', label: 'course:registration_course.publish_course_option.public' },
  { value: 'PRIVATE', label: 'course:registration_course:publish_course_option.private' }
]

export const PAID_COURSE_OPTION = [
  { value: 2, label: 'registration_course.paid_course_option.free' },
  { value: 1, label: 'registration_course.paid_course_option.paid' }
]

export const PAID_COURSE_OPTION_TEXT = [
  { value: 'FREE', label: 'registration_course.paid_course_option.free' },
  { value: 'PAID', label: 'registration_course.paid_course_option.paid' }
]

export const OWNER_OPTION = [
  { value: 1, label: 1 },
  { value: 5, label: 5 },
  { value: 10, label: 10 }
]

export const NUMBER_OF_MEMBERS = [
  { value: '1', label: 'common:number_of_member.1' },
  { value: '10', label: 'common:number_of_member.2~10' },
  { value: '50', label: 'common:number_of_member.11~50' },
  { value: '100', label: 'common:number_of_member.51~100' },
  { value: '500', label: 'common:number_of_member.101~500' },
  { value: '1000', label: 'common:number_of_member.501~1000' },
  { value: '10000', label: 'common:number_of_member.1000~' }
]

export const UNIT_TYPE = {
  LESSON: 'lesson',
  TEST: 'test',
  SURVEY: 'survey',
  REPORT: 'report',
  SEMINAR: 'seminar'
}

export const PUBLISH_TYPE = {
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE'
}

export const OPTIONAL_OR_REQUIRED_ANSWER = [
  { value: 'UNREQUIRED', label: 'options.optional' },
  { value: 'REQUIRED', label: 'options.required' }
]

export const OPTIONAL_OR_REQUIRED_COURSE = [
  { value: false, label: 'common:label_optional' },
  { value: true, label: 'common:label_required' }
]

export const RESTRICT_ANSWER = [
  { value: 'RESTRICT', label: 'create.restrict' },
  { value: 'DO_NOT_RESTRICT', label: 'create.un_restrict' }
]

export const SHOW_MODEL_ANSWER = [
  { value: 'SHOW', label: 'create.show' },
  { value: 'HIDE', label: 'create.un_show' }
]

export const OPTIONAL_OR_REQUIRED_ANSWER_COURSE = [
  { value: 'UNREQUIRED', label: 'options.optional' },
  { value: 'REQUIRED', label: 'options.required' }
]

export const QUESTION_TYPE = [
  { value: 'SELECT_ONE', label: 'options.single_choice' },
  { value: 'CHOOSE_MANY', label: 'options.multiple_choice' },
  { value: 'DESCRIPTION', label: 'options.description' }
]

export const QUESTION_TYPE_SELECT = [
  { value: null, label: 'common:select_all' },
  { value: 'SELECT_ONE', label: 'unit_setting:question_setting.single_choice' },
  { value: 'CHOOSE_MANY', label: 'unit_setting:question_setting.multiple_choice' },
  { value: 'DESCRIPTION', label: 'unit_setting:question_setting.description_choice' }
]

export const STATUS = [
  { value: true, label: 'common:enable' },
  { value: false, label: 'common:disabled' }
]

export const TARGET_RANGE = [
  { value: false, label: 'auto_assignment_course:create_automatic.condition_specification' },
  { value: true, label: 'auto_assignment_course:create_automatic.everyone' }
]

export const MONTH = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'Mar' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' }
]
